import { ChangeEvent } from 'react';
import { Control, Controller } from 'react-hook-form';

type RawFieldsProps = {
  name: string;
  control: Control<any>;
  type?: 'text' | 'number';
  parseValue?: (value: string) => string;
  maxLength?: number;
  inputMode?: 'text' | 'numeric' | 'email';
  classNames?: {
    error?: string;
  };
  placeholder?: string;
  oneCreditCredit365Beecredit?: boolean;
};

const RawFields = (props: RawFieldsProps) => {
  const {
    name,
    control,
    type = 'text',
    parseValue,
    maxLength,
    inputMode = 'text',
    classNames,
    placeholder
  } = props;

  const getErrorStyle = () =>
    classNames && classNames.error ? classNames.error : 'error-text';

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, name }, fieldState: { error } }) => {
        const onChangeHandler = (evt: ChangeEvent<HTMLInputElement>) => {
          let inputValue = evt.target.value;
          if (inputMode !== 'email') {
            inputValue = inputValue.replace(/[^A-Za-z ]/g, '');
            inputValue = inputValue.toUpperCase();
          }
          if (parseValue) {
            return onChange(parseValue(inputValue));
          }
          return onChange(inputValue);
        };

        return (
          <>
            <input
              value={value}
              onChange={onChangeHandler}
              name={name}
              type={type}
              maxLength={maxLength}
              inputMode={inputMode}
              placeholder={placeholder}
            />
            {error && <p className={getErrorStyle()}>{error.message}</p>}
          </>
        );
      }}
    />
  );
};

export default RawFields;
